import {
  ILeanBrandTileRendererBaseProps,
  LeanBrandTileRendererBase,
} from "@faire/retailer-visitor-shared/components/LeanBrandTileRenderer/__internal__/LeanBrandTileRendererBase";
import * as React from "react";

type IProps = Pick<
  ILeanBrandTileRendererBaseProps,
  | "brandPageQueryParams"
  | "brandTile"
  | "categoryUrlIdList"
  | "filterKeys"
  | "favoriteBrand"
  | "unFavoriteBrand"
  | "eventId"
  | "pageType"
  | "title"
  | "onClick"
  | "signUpTracking"
  | "customButton"
  | "topPadding"
>;

export const LeanBrandTileRenderer: React.FC<IProps> = (props) => (
  <LeanBrandTileRendererBase {...props} />
);
